module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/list-icon-26e2a65ad9f0b2975c055a282531ab2f.png";